import { combineReducers } from 'redux';
import fieldsReducer from './form';
import errorReducer from './errors';
import { persistReducer } from 'redux-persist';

// we use sessionStorage instead of localStorage because the data in localStorage is never expired.
// sessionStorage keeps data along with the tab the user opens, so different tabs would create different session storage
// once the user close the tab or window, the data in sessionStorage will be removed. Also, sessionStorage has such
// capability of caching and restoring data in case of the browser crashes abnormally.
import sessionStorage from 'redux-persist/lib/storage/session';

const fieldsPersistConfig = {
    key: 'fields',
    storage: sessionStorage,
    blacklist: ['ein', 'password', 'ssn'] // never store these three values in session since they are Class 2 data
};

const rootPersistConfig = {
    key: 'zettle_obd',
    storage: sessionStorage,
    blacklist: ['fields', 'errors', 'router']
};

const createRootReducer = (routerReducer) =>
    persistReducer(
        rootPersistConfig,
        combineReducers({
            router: routerReducer,
            fields: persistReducer(fieldsPersistConfig, fieldsReducer),
            errors: errorReducer
        })
    );

export default createRootReducer;
